import { Aligner } from '@alfa-bank/site-aligner';
import { BlockDesktop as Block } from '@alfa-bank/site-block/desktop';
import { Button } from '@alfa-bank/site-button-v2';
import { Grid } from '@alfa-bank/site-grid-universal';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';
import { sendEvent } from '@alfa-bank/site-helpers-common/browser/send-event';
import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { useNamedContainers } from '@alfa-bank/site-named-container/utils';

import { StepDesktop as Step } from '../components/step/desktop';
import type { IDepsDesktop, TActionStepsComponentDesktop } from '../models';
import styles from '../components/step/styles/styles.css';

import { ActionSteps as Component } from './action-steps-desktop';

export const ActionStepsDesktop = createWidget<IDepsDesktop, TActionStepsComponentDesktop>({
    Aligner,
    Block,
    Button,
    Grid,
    Step,
    Text,
    sendEvent,
    styles,
    useNamedContainers,
})(Component);
